import { useTranslate } from '@tolgee/react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setPostDataAttribute } from '../../../../../redux/slices/lomavisCreator/lomavisCreator';

export const AdditionalOptionsDisableComments: React.FC<any> = ({ platform }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const additionalPublicationData = useSelector(
    (state: any) =>
      state.lomavisCreator.postData?.[platform]?.additional_publication_data || {}
  );

  return (
    <div className="d-flex justify-content-between align-items-center">
      <span>{t('lomavisCreator.additionalOptions.disableComments')}</span>
      <Form.Check
        type="switch"
        id={`disable-comments-switch-${String(platform)}`}
        checked={Boolean(additionalPublicationData?.comments_disabled)}
        onChange={(e) => {
          dispatch(
            setPostDataAttribute({
              platform,
              attribute: 'additional_publication_data',
              value: {
                ...additionalPublicationData,
                comments_disabled: e.target.checked
              }
            })
          );
        }}
      />
    </div>
  );
};
